export class UserDegree {
  id: number;
  student_id: number;
  institution: string;
  degree: string;
  study_card: string;
  validity: Date;
  status_message: string;
  status: number;
  validate_at: Date;
  created_at: Date;
  updated_at: Date;
  degree_category?: { id: number; name: string; };
  degree_year?: { id: number; name: string; };
}